import { useState, useEffect, useCallback } from 'react'
import { supabase } from '@/lib/supabase'
import { useOnlineStatus } from './useOnlineStatus'

export function useMobilePolicies(userProfileId) {
  const isOnline = useOnlineStatus()
  const [policies, setPolicies] = useState([])
  const [pendingCount, setPendingCount] = useState(0)
  const [overdueCount, setOverdueCount] = useState(0)
  const [loading, setLoading] = useState(true)

  const fetchPolicies = useCallback(async () => {
    if (!userProfileId) return
    setLoading(true)

    if (isOnline) {
      try {
        const { data, error } = await supabase.rpc('app_get_user_policies_v2', {
          p_user_id: userProfileId,
        })
        if (error) throw error
        setPolicies(data?.policies || [])
        setPendingCount(data?.pending_count || 0)
        setOverdueCount(data?.overdue_count || 0)
      } catch (err) {
        console.error('[Policies] Error:', err)
      }
    }

    setLoading(false)
  }, [userProfileId, isOnline])

  useEffect(() => {
    fetchPolicies()
  }, [fetchPolicies])

  const acknowledgePolicy = useCallback(async (policyId) => {
    if (!userProfileId) return false
    try {
      const { data, error } = await supabase.rpc('app_acknowledge_policy_v2', {
        p_user_id: userProfileId,
        p_policy_id: policyId,
      })
      if (error) throw error
      if (data) {
        setPolicies(prev =>
          prev.map(p => p.id === policyId
            ? { ...p, status: 'acknowledged', acknowledged_date: new Date().toISOString() }
            : p
          )
        )
        setPendingCount(prev => Math.max(0, prev - 1))
      }
      return data
    } catch (err) {
      console.error('[Policies] Acknowledge error:', err)
      throw err
    }
  }, [userProfileId])

  return { policies, pendingCount, overdueCount, loading, acknowledgePolicy, refetch: fetchPolicies }
}
